import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {Skeleton} from '../skeleton';

/*
 * Props.
 */

interface MappingHeaderProps {
  sourceImg: string;
  sourceTitle: ReactNode;
  destinationImg: string;
  destinationTitle: ReactNode;
  isLoading?: boolean;
}

/*
 * Style.
 */

export const StyledHeaderCellWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 12px 12px 8px;
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.semibold};
  line-height: 16px;
`;

const StyledImg = styled.img`
  margin-right: 8px;
  vertical-align: top;
`;

const StyledHeaderTitleDiv = styled.div`
  vertical-align: top;
`;

/*
 * Component.
 */

export const MappingHeader: FC<MappingHeaderProps> = (props) => {
  const {sourceImg, sourceTitle, destinationImg, destinationTitle, isLoading} = props;

  if (isLoading) {
    return renderLoadingState();
  }
  return (
    <>
      {renderHeader(sourceImg, sourceTitle)}
      <div />
      {renderHeader(destinationImg, destinationTitle)}
      <div />
    </>
  );
};

/*
 * Helpers.
 */

function renderLoadingState() {
  return (
    <>
      <StyledHeaderCellWrapperDiv>
        <Skeleton width="100%" height="16px" />
      </StyledHeaderCellWrapperDiv>
      <div />
      <StyledHeaderCellWrapperDiv>
        <Skeleton width="100%" height="16px" />
      </StyledHeaderCellWrapperDiv>
      <div />
    </>
  );
}

function renderHeader(sourceImg: string, sourceTitle: ReactNode) {
  return (
    <StyledHeaderCellWrapperDiv>
      <StyledImg src={sourceImg} alt="logo" />
      <StyledHeaderTitleDiv>{sourceTitle}</StyledHeaderTitleDiv>
    </StyledHeaderCellWrapperDiv>
  );
}
